import { render, staticRenderFns } from "./handitemjiaban.vue?vue&type=template&id=a5c5142e&scoped=true"
import script from "./handitemjiaban.vue?vue&type=script&lang=js"
export * from "./handitemjiaban.vue?vue&type=script&lang=js"
import style0 from "./handitemjiaban.vue?vue&type=style&index=0&id=a5c5142e&prod&lang=css"
import style1 from "./handitemjiaban.vue?vue&type=style&index=1&id=a5c5142e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c5142e",
  null
  
)

export default component.exports